// Sekmeli navigasyon — kart içinde sayfalar arası geçiş
// items: [{ key, label, icon?, badge?, disabled?, hidden? }]
import React from 'react';

export default function CardTabs({ items = [], active, onChange, compact = false }) {
  const visible = items.filter(t => !t.hidden);
  return (
    <div
      role="tablist"
      style={{
        display: 'flex',
        gap: 0,
        overflowX: 'auto',
        borderBottom: '1px solid var(--border-secondary)',
        marginBottom: 14,
      }}
    >
      {visible.map(tab => {
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            role="tab"
            aria-selected={isActive}
            disabled={tab.disabled}
            onClick={() => !tab.disabled && onChange && onChange(tab.key)}
            style={{
              padding: compact ? '7px 10px' : '9px 14px',
              background: 'transparent',
              border: 'none',
              borderBottom: isActive ? '2px solid var(--accent-primary)' : '2px solid transparent',
              color: isActive ? 'var(--accent-primary)' : (tab.disabled ? 'var(--text-tertiary)' : 'var(--text-secondary)'),
              fontSize: compact ? '0.78rem' : '0.82rem',
              fontWeight: isActive ? 700 : 500,
              cursor: tab.disabled ? 'not-allowed' : 'pointer',
              whiteSpace: 'nowrap',
              display: 'inline-flex', alignItems: 'center', gap: 6,
              transition: 'all 0.15s',
              opacity: tab.disabled ? 0.5 : 1,
              marginBottom: -1, // border'la flush dur
            }}
          >
            {tab.icon && <span style={{ fontSize: '0.9rem' }}>{tab.icon}</span>}
            {tab.label}
            {tab.badge != null && (
              <span style={{
                fontSize: '0.62rem',
                padding: '1px 6px',
                borderRadius: 'var(--r-full)',
                background: isActive ? 'var(--accent-primary)' : 'var(--text-tertiary)',
                color: '#fff',
                fontWeight: 700,
                marginLeft: 2,
              }}>{tab.badge}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
